module.exports = __webpack_public_path__ + "assets/videojs.a364bd80.svg";